/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 22:20:26
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {CompareTaskConfirmDOI} from "./api/compareTaskConfirmApi";
import CompareTaskConfirmService from "./service/compareTaskConfirmService";
import './compareTaskConfirm.less';

@Component({name: 'compare-task-confirm'})
export default class CompareTaskConfirm extends BasicSearchPage<CompareTaskConfirmService, CompareTaskConfirmDOI.RowDataI, CompareTaskConfirmDOI.QueryRowDataParamsI> {

	checkBoxShow = true
    
    @override
    renderHead(h) {
        return <div></div>
    }
	@override
	loadService () {
		this.service = new CompareTaskConfirmService(this)
	}
}